import { Box } from '@mui/material';

import { RouteCollapse } from '@/components/routing/RouteCollapse';
import { useRoutes } from '@/hooks/useRoutes';
import { TriasService } from '@/modules/TriasService';
import { useRoutesStore } from '@/stores/useRoutesStore';
import { Mode } from '@/types/Mode';

interface RoutingResultsProp {
  showDetails?: () => void;
}

export function RoutingResults({ showDetails }: RoutingResultsProp) {
  const selectedMode = useRoutesStore((state) => state.selectedMode);
  const routes = useRoutes();

  const individualRoute = selectedMode.mode && TriasService.getIndividualRoute(routes[selectedMode.mode].data);
  const publicRoutes =
    selectedMode.mode && routes[selectedMode.mode].data?.serviceDelivery?.deliveryPayload?.tripResponse?.tripResult;

  return (
    <Box
      sx={{
        mt: 2,
      }}
    >
      {[Mode.PUBLIC_TRANSPORT, Mode.BIKE_AND_RIDE, Mode.PARK_AND_RIDE].includes(selectedMode.mode as Mode) ? (
        publicRoutes?.map((route, publicIndex) => (
          <RouteCollapse key={route.resultId} handleDetails={showDetails} publicIndex={publicIndex} route={route} />
        ))
      ) : (
        <RouteCollapse handleDetails={showDetails} route={individualRoute} />
      )}
    </Box>
  );
}
